import React, {useEffect, useState} from "react";
import neverLandUtils from "../../utils/NeverLandUtils";
import {getFetcherAnalysis} from "../../utils/fetcher_gameAnlysis";
import {GET_RANK_DATA_API} from "../../constants/api_constants";
import {getImage} from "../../constants/constants";

const RankingTable = ({dataId, analysisType}) => {
  const [rankList, setRankList] = useState([]);
  const [homeName, setHomeName] = useState(null);
  const [awayName, setAwayName] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isNullData, setIsNullData] = useState(false);

  useEffect(() => {
    getRankData();
  }, []);

  const getRankData = () => {
    // 최근 전적
    getFetcherAnalysis().get(GET_RANK_DATA_API + `?dataId=${dataId}&analysisType=${analysisType}`)
        .then(res => {
          const {responseIsSuccess, data, responseResultDescription} = res.data;
          if (responseIsSuccess) {
            if(data[0].rankData.length === 0) {
              setIsNullData(true);
              setIsLoading(false);
              return;
            }
            setRankList(data[0]?.rankData || []);
            setHomeName(data[0].homeTeamName);
            setAwayName(data[0].awayTeamName);

            setIsLoading(false);
          } else {
            console.log("데이터 불러오기 실패 -> ", responseResultDescription);
            setIsNullData(true);
            setIsLoading(false);
          }
        }).catch(err => console.log(err));
  }

  function isSameTeam(currentName, sourceName) {
    if (currentName.endsWith('..')) {
      // 이름 길어서 잘릴경우 잘리기전까지 비교
      let c = currentName.replace(' ', '');
      c = c.substring(0, c.length - 2);
      let s = sourceName.replace(' ', '');
      if (s.length > c.length) {
        return c === s.substring(0, c.length);
      }
    }
    return currentName === sourceName;
  }


  if (isLoading) {
    return (
        <div className="w-full h-screen flex flex-col justify-center items-center fixed top-0 left-0 overflow-hidden">
          <img src={getImage('loadingImage')} alt="loadingImage" className="h-32 w-auto"/>
          <span className="font-bold text-sky-700"> 데이터 불러오는중... </span>
        </div>
    )
  }
  if (isNullData) {
    return (
        <div className="w-full h-screen flex flex-col justify-center items-center fixed top-0 left-0 overflow-hidden">
          <img src={getImage('notFound')} alt="notFoundImage" className="h-40 w-auto"/>
          <span className="font-bold text-indigo-800 pt-3 text-lg pointer-events-auto"> 데이터가 없습니다. </span>
        </div>
    )
  }

  return (
      <div className="w-full h-full">
        <span className="text-xl font-bold px-2">순위</span>
        <div className="w-full border-t-2 border-gray-900 my-1"/>

        <div className="max-h-[calc(100%-10rem)] mt-3 mb-5">
          <table className="w-full text-sm">
            <thead className="text-center bg-gray-900 text-white">
            <tr>
              <th className="py-1.5">순위</th>
              <th>팀명</th>
              <th>경기</th>
              <th>승점</th>
              <th>승</th>
              <th>무</th>
              <th>패</th>
              <th>득점</th>
              <th>실점</th>
              <th>득실차</th>
            </tr>
            </thead>

            <tbody className="divide-y divide-stone-300 text-center border-y border-gray-300">
            {rankList?.map((data, index) => {
              const isHomeTeam = isSameTeam(data.teamName, homeName);
              const isAwayTeam = isSameTeam(data.teamName, awayName);

              return (
                  <tr key={index}
                      className={neverLandUtils.classNames(isHomeTeam ? "ring-2 ring-red-600 bg-red-100" : isAwayTeam ? "ring-2 ring-blue-600 bg-blue-100" : "ring-1 ring-gray-100", "")}
                  >
                    <td className="p-1.5 py-2">{index + 1}</td>
                    <td>
                      <p className={neverLandUtils.classNames(isHomeTeam ? "bg-red-600 text-white" : isAwayTeam ? "bg-blue-600 text-white" : "bg-white ring-1 ring-gray-300", "rounded-xl p-1 shadow-md")}>
                        {data.teamName}
                      </p>
                    </td>
                    <td>{data.game}</td>
                    <td>{data.winningPoint}</td>
                    <td>{data.win}</td>
                    <td>{data.draw}</td>
                    <td>{data.lose}</td>
                    <td>{data.getPoint}</td>
                    <td>{data.lostPoint}</td>
                    <td>{data.pointDifference}</td>
                  </tr>
              )
            })}
            </tbody>
          </table>
        </div>
      </div>
  )
}
export default RankingTable;